import { render, staticRenderFns } from "./mobileNewsDetail.vue?vue&type=template&id=34b83a41&scoped=true"
import script from "./mobileNewsDetail.vue?vue&type=script&lang=js"
export * from "./mobileNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./mobileNewsDetail.vue?vue&type=style&index=0&id=34b83a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b83a41",
  null
  
)

export default component.exports